import React from "react";
import EditableDateRangeFilter from "./EditableDateRangeFilter";
import EditableWarehouseFilter from "./EditableWarehouseFilter";
import EditableCostCenterFilter from "./EditableCostCenterFilter";
import FilterFields from "./fields/FilterFields";
import Box from "@mui/material/Box";
import useRunTimeFilters from "./hooks/useRunTimeFilters";

export default function RunTimeFiltersDisplay({ options, project, onChange }) {
  const { hasFilters, filters } = useRunTimeFilters(options, project);

  const handleDateRangeChange = (field, value) => {
    const newDateRange = {
      ...options?.date_range,
      [field]: value,
    };

    const newOptions = {
      ...options,
      date_range: newDateRange,
    };

    onChange(newOptions);
  };

  const handleWarehouseChange = warehouse => {
    const newOptions = {
      ...options,
      warehouse_id: warehouse?.id || null,
    };

    onChange(newOptions);
  };

  const handleCostCenterChange = costCenter => {
    const newOptions = {
      ...options,
      cost_center_id: costCenter?.id || null,
    };

    onChange(newOptions);
  };

  // Asset field filters are edited inline via Formik's parent context using FilterFields component.

  if (!hasFilters) {
    return null;
  }

  return filters.map(filter => {
    switch (filter.type) {
      case "date_range":
        return (
          <EditableDateRangeFilter
            key="date_range"
            startDate={filter.startDate}
            endDate={filter.endDate}
            onStartDateChange={value => handleDateRangeChange("start_date", value)}
            onEndDateChange={value => handleDateRangeChange("end_date", value)}
          />
        );
      case "warehouse":
        return (
          <EditableWarehouseFilter
            key="warehouse"
            warehouse={filter.warehouse}
            warehouses={project?.warehouses || []}
            onWarehouseChange={handleWarehouseChange}
          />
        );
      case "cost_center":
        return (
          <EditableCostCenterFilter
            key="cost_center"
            costCenter={filter.costCenter}
            costCenters={project?.costCenters || []}
            onCostCenterChange={handleCostCenterChange}
          />
        );
      case "asset_field_filters":
        return (
          <Box key="asset_field_filters" mb={2}>
            <FilterFields name="options.asset_field_filters" />
          </Box>
        );
      default:
        return null;
    }
  });
}
